import * as yup from "yup";

const billingValidationSchema = yup.object().shape({
  contract_id: yup.string(),
  client_id: yup.string().required("Client ID required"),
  price_minor: yup.number().required("Price required").min(0),
  currency: yup.string().required(),

  contract_start: yup
    .date()
    .nullable()
    .required("Start date required"),

  contract_end: yup
    .date()
    .nullable()
    .required("End date required")
    .min(
      yup.ref("contract_start"),
      "End date cannot be earlier than start date"
    ),

  status: yup.string().required(),
});

export default billingValidationSchema;